module.exports = __webpack_public_path__ + "static/media/icono_corazon_detalle_vacio.5f592c0c.svg";